module.exports = __webpack_public_path__ + "static/img/manual-10.7631e70.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-10.png
// module id = /GDL
// module chunks = 4